'use client';

import { useParams, usePathname } from 'next/navigation';
import { useSuspenseQuery } from '@apollo/client/react';
import { groupLayoutQuery } from '@/apollo/groups';
import Main from '@/components/main';
import GroupHeader from '@/components/groups/header';

type Props = {
  children: React.ReactNode;
};

const GroupLayoutClient = ({ children }: Props) => {
  const { slug } = useParams();
  const pathname = usePathname();
  const { data } = useSuspenseQuery(groupLayoutQuery, {
    variables: { slug },
  });

  let tab = 'overview';
  if (pathname.includes('/calendar')) {
    tab = 'calendar';
  } else if (pathname.includes('/posts')) {
    tab = 'posts';
  } else if (pathname.includes('/photos')) {
    tab = 'photos';
  }

  return (
    <Main compact>
      <GroupHeader group={data.group} tab={tab} />
      {children}
    </Main>
  );
};

export default GroupLayoutClient;
